import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBuilders, getSellers } from '../../../selectors/newbuilding';
import { selectPromoInfo } from '../../../selectors/promoInfo';

export const useAvailableContacts = () => {
  const promo = useSelector(selectPromoInfo);
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);

  return useMemo(() => {
    if (!promo) {
      return {
        builders: [],
        sellers: [],
      };
    }

    if (!promo.authorRealtyUserId) {
      return {
        builders: builders.filter(contact => contact.showPhone),
        sellers: sellers.filter(contact => contact.showPhone && contact.name),
      };
    }

    return {
      builders: builders.filter(contact => contact.realtyUserId === promo.authorRealtyUserId && contact.showPhone),
      sellers: sellers.filter(
        contact => contact.realtyUserId === promo.authorRealtyUserId && contact.showPhone && contact.name,
      ),
    };
  }, [promo, builders, sellers]);
};
